import { cn } from '@rocco/utils/cn';

interface HDEPanelSpeakerCardProps {
    speaker: {
        name: string;
        role: string;
        link?: string;
        imageUrl?: string;
    };
    className?: string;
}

/**
 * Speaker portrait card used by the HDE panel lineup sections.
 */
export const HDEPanelSpeakerCard = ({
    speaker,
    className,
}: HDEPanelSpeakerCardProps) => {
    const content = (
        <div
            className={cn(
                'group relative h-[38rem] w-[25.5rem] shrink-0 overflow-hidden bg-[#2e2e2d]',
                className,
            )}
        >
            <SpeakerImage speaker={speaker} />
            <SpeakerCardFrame />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent px-[1.1875rem] pb-[4.5rem] pt-[7rem]">
                <p className="font-display text-[1.375rem] font-medium uppercase leading-[0.9] tracking-[-0.04125rem] text-white">
                    {speaker.name}
                </p>
                <p className="mt-[0.1875rem] font-display text-[1.375rem] font-[450] uppercase leading-[0.9] tracking-[-0.04125rem] text-[#969696]">
                    {speaker.role}
                </p>
            </div>
        </div>
    );

    if (!speaker.link) {
        return content;
    }

    return (
        <a
            href={speaker.link}
            target="_blank"
            rel="noopener noreferrer"
            className="block h-[38rem] w-[25.5rem]"
        >
            {content}
        </a>
    );
};

const SpeakerImage = ({
    speaker,
}: Pick<HDEPanelSpeakerCardProps, 'speaker'>) => {
    if (!speaker.imageUrl) {
        return <div className="absolute inset-0 bg-[#2e2e2d]" />;
    }

    return (
        <img
            src={speaker.imageUrl}
            alt={speaker.name}
            className="absolute inset-0 h-full w-full object-cover object-bottom grayscale"
        />
    );
};

const SpeakerCardFrame = () => (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute left-0 right-0 top-[2.875rem] border-t border-dashed border-white/40" />
        <div className="absolute bottom-[2.875rem] left-0 right-0 border-t border-dashed border-white/40" />
        <span className="absolute left-[1.1875rem] top-[1.1875rem] size-[0.5rem] rounded-full bg-white" />
        <span className="absolute right-[1.4375rem] top-[1.1875rem] size-[0.5rem] rounded-full bg-white" />
        <span className="absolute bottom-[1.1875rem] left-[1.1875rem] size-[0.5rem] rounded-full bg-white" />
        <span className="absolute bottom-[1.1875rem] right-[1.4375rem] size-[0.5rem] rounded-full bg-white" />
    </div>
);
